import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MicroServiceService {
  private baseUrl = environment.authApiUrl + "genai-mic/auth/v3/system";

  constructor(private http: HttpClient) { }

  getMicroServices() {
    return this.http.get(this.baseUrl + "/list/microservices");
  }

  getMicroservicePermissions(microserviceId: string) {
    return this.http.get(
      this.baseUrl + "/microservices/" + microserviceId + "/list/permissions"
    );
  }

}
